import { calculateColorSet } from './utils';
import { CalculatePalette } from './types';
import { CUSTOMIZATION_DEFAULT } from '../../theme';

const calculatePalette: CalculatePalette = ({
    backgroundColor,
    surfaceColor,
    interactiveColor,
} = {}) => {
    return {
        background: backgroundColor
            ? calculateColorSet(backgroundColor)
            : CUSTOMIZATION_DEFAULT['background'],
        surface: surfaceColor ? calculateColorSet(surfaceColor) : CUSTOMIZATION_DEFAULT['surface'],
        interactive: interactiveColor
            ? calculateColorSet(interactiveColor)
            : CUSTOMIZATION_DEFAULT['interactive'],
    };
};

export default calculatePalette;
